import { GET_USER_PROFILE, USER_PROFILE_UPDATE } from "../types";
import userProfileService from "reduxStore/service/userProfileService";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";

export const editUserProfileUpdate = (item) => async (dispatch) => {
  try {
    const res = await userProfileService.editUserProfileUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_PROFILE_UPDATE,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const editAgentProfileUpdate = (item) => async (dispatch) => {
  try {
    const res = await userProfileService.editAgentProfileUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_PROFILE_UPDATE,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getUserProfile = (item) => async (dispatch) => {
  try {
    const res = await userProfileService.getUserProfile(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_USER_PROFILE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
